var map = {
	"./add-block.svg": 26976,
	"./add-object.svg": 30283,
	"./align-bottom.svg": 21738,
	"./align-center.svg": 69697,
	"./align-left.svg": 63225,
	"./align-middle.svg": 71766,
	"./align-right.svg": 60013,
	"./align-top.svg": 59939,
	"./aspect-ratio-lock.svg": 82438,
	"./background-code.svg": 86891,
	"./circle-plus.svg": 23507,
	"./drag_horizontal.svg": 516,
	"./drag_vertical.svg": 11145,
	"./edit.svg": 20181,
	"./foreground-code.svg": 92640,
	"./full-video.svg": 33837,
	"./icon-3-dot-menu-vertical.svg": 56942,
	"./icon-after-step.svg": 81382,
	"./icon-app-menu.svg": 30959,
	"./icon-app.svg": 72712,
	"./icon-arguments.svg": 7439,
	"./icon-background.svg": 73321,
	"./icon-before-step.svg": 95198,
	"./icon-block.svg": 70808,
	"./icon-build.svg": 34912,
	"./icon-camera.svg": 15484,
	"./icon-clone.svg": 66591,
	"./icon-code.svg": 40330,
	"./icon-command.svg": 46803,
	"./icon-commands.svg": 57963,
	"./icon-critical.svg": 79513,
	"./icon-do-until.svg": 6681,
	"./icon-down-arrow.svg": 26543,
	"./icon-download.svg": 10253,
	"./icon-edit.svg": 62579,
	"./icon-else.svg": 67822,
	"./icon-error-code-disabled.svg": 98007,
	"./icon-error-code.svg": 89312,
	"./icon-error-task.svg": 93366,
	"./icon-error-warning-red.svg": 44006,
	"./icon-error-warning.svg": 87567,
	"./icon-example.svg": 16511,
	"./icon-folder.svg": 66276,
	"./icon-foreach.svg": 31873,
	"./icon-hit.svg": 90127,
	"./icon-html.svg": 29483,
	"./icon-if-else.svg": 95134,
	"./icon-if.svg": 65091,
	"./icon-indent.svg": 21690,
	"./icon-info.svg": 3265,
	"./icon-interval.svg": 46469,
	"./icon-introduction.svg": 15270,
	"./icon-keypress.svg": 48498,
	"./icon-lock.svg": 88959,
	"./icon-move-end.svg": 29593,
	"./icon-move-start.svg": 5956,
	"./icon-must-use.svg": 83334,
	"./icon-nav-upload.svg": 57268,
	"./icon-new.svg": 34116,
	"./icon-object.svg": 15211,
	"./icon-out-bounds.svg": 50626,
	"./icon-paint.svg": 3423,
	"./icon-placeholder-command-add.svg": 41844,
	"./icon-placeholder-object-add.svg": 12239,
	"./icon-pointer-clicked.svg": 26273,
	"./icon-pointer-moved.svg": 24843,
	"./icon-pointer-pressed.svg": 66790,
	"./icon-pointer-released.svg": 31022,
	"./icon-pointer-v2.svg": 8858,
	"./icon-pointer.svg": 29784,
	"./icon-practice.svg": 81646,
	"./icon-prevent.svg": 14143,
	"./icon-python.svg": 1574,
	"./icon-remix.svg": 54139,
	"./icon-rename.svg": 62184,
	"./icon-repeat.svg": 33095,
	"./icon-reset.svg": 56874,
	"./icon-save-confirmed.svg": 12847,
	"./icon-save-default-warning.svg": 10756,
	"./icon-save-default.svg": 26488,
	"./icon-save-failure.svg": 68583,
	"./icon-save-loading.svg": 58646,
	"./icon-save.svg": 99733,
	"./icon-share.svg": 50398,
	"./icon-solve.svg": 23848,
	"./icon-sound.svg": 40756,
	"./icon-sound_icon.svg": 68959,
	"./icon-start-end.svg": 36587,
	"./icon-text-bold.svg": 66858,
	"./icon-text-colour.svg": 39528,
	"./icon-text-italic.svg": 80229,
	"./icon-text-outline.svg": 57049,
	"./icon-text-shadow.svg": 77293,
	"./icon-text-underline.svg": 45306,
	"./icon-then.svg": 33155,
	"./icon-this.svg": 71159,
	"./icon-time-out.svg": 60505,
	"./icon-turn-anti-clockwise.svg": 23198,
	"./icon-turn-clockwise.svg": 40176,
	"./icon-type-app.svg": 92937,
	"./icon-type-command.svg": 98311,
	"./icon-type-controls.svg": 34409,
	"./icon-type-events.svg": 18348,
	"./icon-type-object.svg": 52160,
	"./icon-type-operators.svg": 57257,
	"./icon-type-pointer.svg": 80062,
	"./icon-type-sound.svg": 46125,
	"./icon-type-values.svg": 64531,
	"./icon-type-variable.svg": 13850,
	"./icon-update.svg": 99290,
	"./icon-upload.svg": 48734,
	"./icon-x.svg": 78882,
	"./icon_animation.svg": 20703,
	"./icon_button.svg": 5257,
	"./icon_fullscreen.svg": 13973,
	"./icon_fullscreen_exit.svg": 90091,
	"./icon_hide.svg": 31079,
	"./icon_image.svg": 62680,
	"./icon_key.svg": 58383,
	"./icon_sound.svg": 92028,
	"./icon_sprite.svg": 67160,
	"./icon_text.svg": 93550,
	"./icon_variable.svg": 32964,
	"./lightbulb.svg": 64741,
	"./loader-spinner.svg": 48155,
	"./maximise.svg": 43796,
	"./minimise.svg": 38363,
	"./paint.svg": 3787,
	"./pan.svg": 95833,
	"./redo.svg": 13537,
	"./screenshot.svg": 76796,
	"./stop.svg": 9962,
	"./tab_edge.svg": 83986,
	"./tree-view.svg": 23602,
	"./undo.svg": 66345,
	"./zoom-in.svg": 90818,
	"./zoom-out.svg": 93261,
	"./zoom-to-fit.svg": 41643,
	"images/icons/add-block.svg": 26976,
	"images/icons/add-object.svg": 30283,
	"images/icons/align-bottom.svg": 21738,
	"images/icons/align-center.svg": 69697,
	"images/icons/align-left.svg": 63225,
	"images/icons/align-middle.svg": 71766,
	"images/icons/align-right.svg": 60013,
	"images/icons/align-top.svg": 59939,
	"images/icons/aspect-ratio-lock.svg": 82438,
	"images/icons/background-code.svg": 86891,
	"images/icons/circle-plus.svg": 23507,
	"images/icons/drag_horizontal.svg": 516,
	"images/icons/drag_vertical.svg": 11145,
	"images/icons/edit.svg": 20181,
	"images/icons/foreground-code.svg": 92640,
	"images/icons/full-video.svg": 33837,
	"images/icons/icon-3-dot-menu-vertical.svg": 56942,
	"images/icons/icon-after-step.svg": 81382,
	"images/icons/icon-app-menu.svg": 30959,
	"images/icons/icon-app.svg": 72712,
	"images/icons/icon-arguments.svg": 7439,
	"images/icons/icon-background.svg": 73321,
	"images/icons/icon-before-step.svg": 95198,
	"images/icons/icon-block.svg": 70808,
	"images/icons/icon-build.svg": 34912,
	"images/icons/icon-camera.svg": 15484,
	"images/icons/icon-clone.svg": 66591,
	"images/icons/icon-code.svg": 40330,
	"images/icons/icon-command.svg": 46803,
	"images/icons/icon-commands.svg": 57963,
	"images/icons/icon-critical.svg": 79513,
	"images/icons/icon-do-until.svg": 6681,
	"images/icons/icon-down-arrow.svg": 26543,
	"images/icons/icon-download.svg": 10253,
	"images/icons/icon-edit.svg": 62579,
	"images/icons/icon-else.svg": 67822,
	"images/icons/icon-error-code-disabled.svg": 98007,
	"images/icons/icon-error-code.svg": 89312,
	"images/icons/icon-error-task.svg": 93366,
	"images/icons/icon-error-warning-red.svg": 44006,
	"images/icons/icon-error-warning.svg": 87567,
	"images/icons/icon-example.svg": 16511,
	"images/icons/icon-folder.svg": 66276,
	"images/icons/icon-foreach.svg": 31873,
	"images/icons/icon-hit.svg": 90127,
	"images/icons/icon-html.svg": 29483,
	"images/icons/icon-if-else.svg": 95134,
	"images/icons/icon-if.svg": 65091,
	"images/icons/icon-indent.svg": 21690,
	"images/icons/icon-info.svg": 3265,
	"images/icons/icon-interval.svg": 46469,
	"images/icons/icon-introduction.svg": 15270,
	"images/icons/icon-keypress.svg": 48498,
	"images/icons/icon-lock.svg": 88959,
	"images/icons/icon-move-end.svg": 29593,
	"images/icons/icon-move-start.svg": 5956,
	"images/icons/icon-must-use.svg": 83334,
	"images/icons/icon-nav-upload.svg": 57268,
	"images/icons/icon-new.svg": 34116,
	"images/icons/icon-object.svg": 15211,
	"images/icons/icon-out-bounds.svg": 50626,
	"images/icons/icon-paint.svg": 3423,
	"images/icons/icon-placeholder-command-add.svg": 41844,
	"images/icons/icon-placeholder-object-add.svg": 12239,
	"images/icons/icon-pointer-clicked.svg": 26273,
	"images/icons/icon-pointer-moved.svg": 24843,
	"images/icons/icon-pointer-pressed.svg": 66790,
	"images/icons/icon-pointer-released.svg": 31022,
	"images/icons/icon-pointer-v2.svg": 8858,
	"images/icons/icon-pointer.svg": 29784,
	"images/icons/icon-practice.svg": 81646,
	"images/icons/icon-prevent.svg": 14143,
	"images/icons/icon-python.svg": 1574,
	"images/icons/icon-remix.svg": 54139,
	"images/icons/icon-rename.svg": 62184,
	"images/icons/icon-repeat.svg": 33095,
	"images/icons/icon-reset.svg": 56874,
	"images/icons/icon-save-confirmed.svg": 12847,
	"images/icons/icon-save-default-warning.svg": 10756,
	"images/icons/icon-save-default.svg": 26488,
	"images/icons/icon-save-failure.svg": 68583,
	"images/icons/icon-save-loading.svg": 58646,
	"images/icons/icon-save.svg": 99733,
	"images/icons/icon-share.svg": 50398,
	"images/icons/icon-solve.svg": 23848,
	"images/icons/icon-sound.svg": 40756,
	"images/icons/icon-sound_icon.svg": 68959,
	"images/icons/icon-start-end.svg": 36587,
	"images/icons/icon-text-bold.svg": 66858,
	"images/icons/icon-text-colour.svg": 39528,
	"images/icons/icon-text-italic.svg": 80229,
	"images/icons/icon-text-outline.svg": 57049,
	"images/icons/icon-text-shadow.svg": 77293,
	"images/icons/icon-text-underline.svg": 45306,
	"images/icons/icon-then.svg": 33155,
	"images/icons/icon-this.svg": 71159,
	"images/icons/icon-time-out.svg": 60505,
	"images/icons/icon-turn-anti-clockwise.svg": 23198,
	"images/icons/icon-turn-clockwise.svg": 40176,
	"images/icons/icon-type-app.svg": 92937,
	"images/icons/icon-type-command.svg": 98311,
	"images/icons/icon-type-controls.svg": 34409,
	"images/icons/icon-type-events.svg": 18348,
	"images/icons/icon-type-object.svg": 52160,
	"images/icons/icon-type-operators.svg": 57257,
	"images/icons/icon-type-pointer.svg": 80062,
	"images/icons/icon-type-sound.svg": 46125,
	"images/icons/icon-type-values.svg": 64531,
	"images/icons/icon-type-variable.svg": 13850,
	"images/icons/icon-update.svg": 99290,
	"images/icons/icon-upload.svg": 48734,
	"images/icons/icon-x.svg": 78882,
	"images/icons/icon_animation.svg": 20703,
	"images/icons/icon_button.svg": 5257,
	"images/icons/icon_fullscreen.svg": 13973,
	"images/icons/icon_fullscreen_exit.svg": 90091,
	"images/icons/icon_hide.svg": 31079,
	"images/icons/icon_image.svg": 62680,
	"images/icons/icon_key.svg": 58383,
	"images/icons/icon_sound.svg": 92028,
	"images/icons/icon_sprite.svg": 67160,
	"images/icons/icon_text.svg": 93550,
	"images/icons/icon_variable.svg": 32964,
	"images/icons/lightbulb.svg": 64741,
	"images/icons/loader-spinner.svg": 48155,
	"images/icons/maximise.svg": 43796,
	"images/icons/minimise.svg": 38363,
	"images/icons/paint.svg": 3787,
	"images/icons/pan.svg": 95833,
	"images/icons/redo.svg": 13537,
	"images/icons/screenshot.svg": 76796,
	"images/icons/stop.svg": 9962,
	"images/icons/tab_edge.svg": 83986,
	"images/icons/tree-view.svg": 23602,
	"images/icons/undo.svg": 66345,
	"images/icons/zoom-in.svg": 90818,
	"images/icons/zoom-out.svg": 93261,
	"images/icons/zoom-to-fit.svg": 41643
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 46138;